"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "capo-d-orlando": {
    "d089ea9a": [{
      "hkey": "0e2f94d6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "bruca": [{
      "hkey": "0e2f94d6",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "capo-d-orlando"
    }],
    "c4f03162": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "certari": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "f31155ce": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-collinari-bastione": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25c5f7df": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "forno-alto": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a94dd991": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "forno-marina": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "d014978a": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "malvicino": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "68333564": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "marmaro": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "90d0535d": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "s-carra": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "e6872d8a": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "san-martino": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bee00be4": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b2c4b057": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "tavola-grande-trazzera-marina": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "72e249f4": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "skipSearch": false
    }],
    "vina": [{
      "hkey": "b30f1cda",
      "slug": "capo-d-orlando",
      "name": "Capo d'Orlando",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;